module.exports = __webpack_public_path__ + "img/iconlist-2.bdcbd358.png";